var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabIconPivotTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 45.145 45.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7340",
    "data-name": "Group 7340",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22644",
    "data-name": "Path 22644",
    d: "M1.25,4.925A3.675,3.675,0,0,1,4.925,1.25h37.8a3.675,3.675,0,0,1,3.675,3.675v37.8a3.675,3.675,0,0,1-3.675,3.675H4.926A3.675,3.675,0,0,1,1.251,42.72ZM4.925,4.4a.525.525,0,0,0-.525.525v37.8a.525.525,0,0,0,.525.525H42.72a.525.525,0,0,0,.525-.525V4.925A.525.525,0,0,0,42.72,4.4Z",
    transform: "translate(0 0)",
    fill: "#9797bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22645",
    "data-name": "Path 22645",
    d: "M24.994,9.254a1.575,1.575,0,0,1,1.575,1.575v14.7A1.575,1.575,0,0,1,24.994,27.1H10.829a1.575,1.575,0,1,1,0-3.15h12.59V10.829A1.575,1.575,0,0,1,24.994,9.254Z",
    transform: "translate(8.803 8.803)",
    fill: "#9797bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22646",
    "data-name": "Path 22646",
    d: "M16.663,14.461a1.575,1.575,0,0,1,0,2.227L13.052,20.3l3.611,3.611a1.575,1.575,0,0,1-2.227,2.227L9.711,21.413a1.575,1.575,0,0,1,0-2.227l4.724-4.724A1.575,1.575,0,0,1,16.663,14.461Z",
    transform: "translate(8.798 14.022)",
    fill: "#9797bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22647",
    "data-name": "Path 22647",
    d: "M18.936,9.711a1.575,1.575,0,0,1,2.227,0l4.724,4.724a1.575,1.575,0,0,1-2.227,2.227l-3.611-3.611-3.611,3.611a1.575,1.575,0,0,1-2.227-2.227Z",
    transform: "translate(13.747 8.798)",
    fill: "#9797bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22648",
    "data-name": "Path 22648",
    d: "M7.825,1.25A1.575,1.575,0,0,1,9.4,2.825V44.82a1.575,1.575,0,1,1-3.15,0V2.825A1.575,1.575,0,0,1,7.825,1.25Z",
    transform: "translate(5.499 0)",
    fill: "#9797bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22649",
    "data-name": "Path 22649",
    d: "M46.395,7.823A1.575,1.575,0,0,1,44.821,9.4l-41.995.04a1.575,1.575,0,0,1,0-3.15l41.995-.04a1.575,1.575,0,0,1,1.576,1.573Z",
    transform: "translate(0 5.499)",
    fill: "#9797bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22650",
    "data-name": "Path 22650",
    d: "M3.25,2.825A1.575,1.575,0,0,1,4.825,1.25h21a1.575,1.575,0,1,1,0,3.15h-21A1.575,1.575,0,0,1,3.25,2.825Z",
    transform: "translate(2.2 0)",
    fill: "#9797bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22651",
    "data-name": "Path 22651",
    d: "M3.25,22.825A1.575,1.575,0,0,1,4.825,21.25h21a1.575,1.575,0,0,1,0,3.15h-21A1.575,1.575,0,0,1,3.25,22.825Z",
    transform: "translate(2.2 21.995)",
    fill: "#9797bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22652",
    "data-name": "Path 22652",
    d: "M22.825,3.25A1.575,1.575,0,0,1,24.4,4.825v10.5a1.575,1.575,0,0,1-3.15,0V4.825A1.575,1.575,0,0,1,22.825,3.25Z",
    transform: "translate(21.995 2.199)",
    fill: "#9797bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22653",
    "data-name": "Path 22653",
    d: "M2.825,3.25A1.575,1.575,0,0,1,4.4,4.825v10.5a1.575,1.575,0,1,1-3.15,0V4.825A1.575,1.575,0,0,1,2.825,3.25Z",
    transform: "translate(0 2.199)",
    fill: "#9797bd",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIconPivotTable);
export default __webpack_public_path__ + "static/media/TabIconPivotTable.65ad295ad22a16d31c7c76f6e8575281.svg";
export { ForwardRef as ReactComponent };